import React from 'react'
import { Icon } from '../../../shared/ui/Icon'
import { MatrixHeaderContainer } from './MatrixHeader.styles.ts'

interface MatrixHeaderProps {
  projectName: string
}

export const MatrixHeader: React.FC<MatrixHeaderProps> = ({ projectName }) => {
  return (
    <MatrixHeaderContainer>
      <Icon type="document" size={18} />
      Матрица состояния документации - {projectName}
    </MatrixHeaderContainer>
  )
}
